import { TSelectField } from 'src/libs/ui-kit';

export enum USER_TYPE {
  UNDEFINED_USER_TYPE = 0,
  CUSTOMER = 1,
  CONTRACTOR = 2,
  EMPLOYEE = 3,
  PARTNER = 4,
}

export enum BLOCKING_REASON_SLUG {
  UNDEFINED_BLOCKING_REASON_SLUG = 0,
  REVOCATION_PERS_DATA = 1,
  END_COOPERATION = 2,
}

export const widgetLabels = {
  userNumber: 'Номер пользователя',
  userType: 'Тип пользователя',
  tenantName: 'Арендатор',
  fullName: 'ФИО',
  birthday: 'Дата рождения',
  isAdmin: 'Роль пользователя',
  socialNetworks: 'Соц. сети',
  positionAndCompany: 'Должность, компания',
  supportTags: 'Тэги от саппорта',
  lockStatus: 'Статус блокировки',
  profileBlockingStatus: 'Статус блокировки',
  profileBlockingReason: 'Причина блокировки',
  profileBlocked: 'Заблокирован',
  profileCreationDate: 'Дата создания профиля',
  profileTags: 'Теги',
} as const;

export const USER_TYPE_OPTIONS: TSelectField<USER_TYPE>[] = [
  {
    label: 'Клиент',
    name: USER_TYPE.CUSTOMER,
  },
  {
    label: 'Исполнитель',
    name: USER_TYPE.CONTRACTOR,
  },
  {
    label: 'Сотрудник',
    name: USER_TYPE.EMPLOYEE,
  },
  {
    label: 'Владелец точки',
    name: USER_TYPE.PARTNER,
  },
];
